.facts {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 10px 28px;
  padding: 10px 18px;
}

.toggle {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  min-height: var(--h-ctl);
  padding: 0;
  border: 0;
  background: none;
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  cursor: pointer;
}

.toggle:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.caret,
.caretOpen {
  transition: transform var(--dur-1) var(--ease-std);
}

.caretOpen {
  transform: rotate(90deg);
}

.group {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px 8px;
}

.name {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
}

.chip {
  display: inline-flex;
  align-items: center;
  max-width: 100%;
  min-height: var(--h-ctl);
  padding: 2px 10px;
  border: 1px solid var(--line);
  border-radius: var(--radius-pill);
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
  font-weight: 600;
  text-align: left;
  cursor: pointer;
}

.chip:hover {
  background: var(--panel-2);
}

.chip:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.warn {
  border-color: var(--warn, var(--line));
}

.body {
  display: flex;
  flex-direction: column;
  gap: 12px;
  font-size: var(--t-body);
  line-height: 1.5;
}

.body p {
  margin: 0;
}

.counsel {
  font-weight: 600;
}

.link {
  align-self: flex-start;
  padding: 0;
  border: 0;
  background: none;
  color: var(--accent);
  font: inherit;
  font-weight: 600;
  cursor: pointer;
}
